<template>
	<div class="user-panel clearfix">
		<header>Dane kontaktowe</header>
		<div class="user-panel-form clearfix">
			<div class="form-col">
				<header class="d-inline">Adres zamieszkania</header>
				<address-main
					:provinces="provinces"
					:countries="countries"
					@updateAbroadTaxPlace="$emit('updateAbroadTaxPlace')"
				/>
			</div>
			<div class="form-col correspondance-addres">
				<header
					v-if="!myFx.correspondenceAddressLikeMainAddress"
					class="d-inline"
				>
					Adres korespondencyjny
				</header>
				<transition name="show-address">
					<address-correspondance
						v-show="!myFx.correspondenceAddressLikeMainAddress"
						:provinces="provinces"
						:countries="countries"
					/>
				</transition>
				<v-checkbox
					:htmlId="'SameCorrespondanceAddress'"
					:checked="myFx.correspondenceAddressLikeMainAddress"
					:label="'Adres korespondencyjny taki jak zamieszkania'"
				/>
			</div>
		</div>
		<div class="user-panel-form clearfix">
			<div class="form-col">
				<v-input
					:label="'Telefon komórkowy'"
					:htmlId="'MobilePhone'"
					:value="myFx.mobilePhone"
				/>

				<v-input
					:label="'Hasło telefoniczne'"
					:htmlId="'MobilePhonePassword'"
					:value="myFx.phonePassword"
					readonly
				/>
			</div>
			<div class="form-col">
				<v-input
					:type="'email'"
					:label="'E-mail'"
					:htmlId="'Email'"
					:value="myFx.email"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { getDictionaryItem } from '@/mixins/get-dictionary-item';
import { getMyFx } from '@/mixins/get-my-fx';

import AddressMain from '@/views/myFx/partial/_AddressMain';
import AddressCorrespondance from '@/views/myFx/partial/_AddressCorrespondance';

export default {
	mixins: [getDictionaryItem, getMyFx],
	components: {
		AddressMain,
		AddressCorrespondance,
	},
	props: {
		countries: {
			type: Array,
			required: true,
		},
		provinces: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style>
.correspondance-addres > section {
	height: 430px;
}

.show-address-enter-active,
.show-address-leave-active {
	transition: all 0.3s ease;
	overflow: hidden;
}

.show-address-enter,
.show-address-leave-to {
	height: 0 !important;
	opacity: 0;
}
</style>
